import { FormControl, styled } from '@mui/material';

export const CustomFormControl = styled(FormControl)(() => ({
  '& .MuiInputBase-readOnly': {
    paddingLeft: '0 !important',
  },
}));
